'use client';
import React, { useState } from 'react';

const ZEC_PRICE_USD = 1139.14;

export default function StatusBar() {
  const [currency, setCurrency] = useState<'ZEC'|'USD'>('ZEC');

  return (
    <div className="statusbar">
      <div className="statusbar-inner">
        <div className="statusbar-side">
          <span className="sb-item">
            <span className="live-dot" style={{'--dot':'6px'} as React.CSSProperties} />
            <span style={{color:'var(--text-2)'}}>Live</span>
          </span>
          <span className="sb-div sb-drop-2" aria-hidden="true" />
          <span className="sb-item sb-drop-2">
            <span>ZSA</span>
            <span aria-hidden="true" style={{width:4,height:4,borderRadius:'50%',background:'var(--text-faint)',display:'inline-block'}} />
            <span className="mono">block 3,482,961</span>
          </span>
          <span className="sb-div sb-drop-1" aria-hidden="true" />
          <a className="sb-link sb-drop-1" href="/terms">Terms</a>
          <span className="sb-div sb-drop-1" aria-hidden="true" />
          <a className="sb-link sb-drop-1" href="/privacy">Privacy</a>
          <span className="sb-div sb-drop-1" aria-hidden="true" />
          <a href="https://x.com/zec_bit" target="_blank" rel="noopener noreferrer" className="sb-link sb-drop-1" aria-label="ZecBit on X">
            <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
              <path d="M9.142 7.193 13.609 2h-1.059L8.671 6.509 5.573 2H2l4.685 6.818L2 14.264h1.059l4.096-4.762 3.272 4.762H14L9.142 7.193Zm-1.45 1.685-.475-.679L3.44 2.797h1.626l3.048 4.36.475.679 3.962 5.667h-1.626L7.692 8.878Z" />
            </svg>
          </a>
        </div>
        <div className="statusbar-side">
          <span className="sb-item">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="https://zecbit.net/icons/token/ZEC.svg" alt="" width={13} height={13} style={{width:13,height:13,borderRadius:'50%',flex:'0 0 auto',display:'block',background:'rgba(244,183,40,.12)'}} />
            <span className="mono" style={{color:'var(--gold)'}}>${ZEC_PRICE_USD.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}</span>
          </span>
          <span className="sb-div sb-drop-1" aria-hidden="true" />
          <a href="https://x.com/zec_bit" className="sb-link sb-item sb-drop-1">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="12" r="9.25"/>
              <path d="M9.4 9.2a2.7 2.7 0 0 1 5.2 1c0 1.8-2.6 2.2-2.6 3.9" strokeLinecap="round"/>
              <path d="M12 17.1v.01" strokeLinecap="round"/>
            </svg>
            Support
          </a>
          <span className="sb-div" aria-hidden="true" />
          <span className="sb-toggle">
            <button data-on={currency==='ZEC'?'1':'0'} onClick={()=>setCurrency('ZEC')}>ZEC</button>
            <button data-on={currency==='USD'?'1':'0'} onClick={()=>setCurrency('USD')}>USD</button>
          </span>
        </div>
      </div>
    </div>
  );
}
